import Page from "@containers/Page/Page";
import PageContent from "@containers/PageContent/PageContent";
import MacDetails from "@pages/Documents/MacDetails/MacDetails";

const MacNew = () => {
    return (
        /* @ts-ignore -- Page is a JS container without prop types (same as MacObsolete) */
        <Page>
            <PageContent className="MacDetails__page">
                <MacDetails/>
            </PageContent>
        </Page>
    );
};

export default MacNew;
